// ─── BLOQUE 48: DASHBOARD SIMPLE RADIO ────────────────────────────────
// Regla: Todo lo importante visible sin navegar.

// ─── 1. TARJETAS DE MÉTRICAS ─────────────────────────────────────────

export interface DashboardMetricCard {
  id: string;
  label: string;
  value: string;
  rawValue: number;
  comparison: string;
  trend: 'up' | 'down' | 'stable';
  trendValue: string;
  icon: string;
  bgColor: string;
  iconBg: string;
  textColor: string;
  subtitle: string;
  link: string;
}

export const dashboardMetricCards: DashboardMetricCard[] = [
  {
    id: 'oyentes-ahora',
    label: 'Oyentes Ahora',
    value: '1,247',
    rawValue: 1247,
    comparison: 'Última hora',
    trend: 'up',
    trendValue: '+12%',
    icon: 'ri-headphone-line',
    bgColor: 'bg-emerald-50',
    iconBg: 'bg-emerald-100',
    textColor: 'text-emerald-600',
    subtitle: '87 en cabina · 1,160 escuchando',
    link: '/admin/live',
  },
  {
    id: 'seguidores',
    label: 'Seguidores',
    value: '8,432',
    rawValue: 8432,
    comparison: 'Este mes',
    trend: 'up',
    trendValue: '+3.2%',
    icon: 'ri-user-heart-line',
    bgColor: 'bg-amber-50',
    iconBg: 'bg-amber-100',
    textColor: 'text-amber-600',
    subtitle: '+256 esta semana',
    link: '/admin/community',
  },
  {
    id: 'ranking',
    label: 'Ranking',
    value: '#12',
    rawValue: 12,
    comparison: 'Global',
    trend: 'up',
    trendValue: '+3 pos.',
    icon: 'ri-medal-line',
    bgColor: 'bg-violet-50',
    iconBg: 'bg-violet-100',
    textColor: 'text-violet-600',
    subtitle: 'Top 5 en tu país',
    link: '/rankings',
  },
  {
    id: 'score',
    label: 'Score RFW',
    value: '892',
    rawValue: 892,
    comparison: 'Máximo: 1,000',
    trend: 'up',
    trendValue: '+24 pts',
    icon: 'ri-bar-chart-2-line',
    bgColor: 'bg-teal-50',
    iconBg: 'bg-teal-100',
    textColor: 'text-teal-600',
    subtitle: 'A 108 del siguiente nivel',
    link: '/admin/analytics',
  },
  {
    id: 'notificaciones',
    label: 'Notificaciones',
    value: '34',
    rawValue: 34,
    comparison: 'Sin leer',
    trend: 'stable',
    trendValue: 'Normal',
    icon: 'ri-notification-3-line',
    bgColor: 'bg-rose-50',
    iconBg: 'bg-rose-100',
    textColor: 'text-rose-600',
    subtitle: '5 urgentes · 12 hoy',
    link: '/admin/notifications',
  },
  {
    id: 'ingresos',
    label: 'Ingresos',
    value: '$1,240',
    rawValue: 1240,
    comparison: 'Este mes',
    trend: 'up',
    trendValue: '+18%',
    icon: 'ri-money-dollar-circle-line',
    bgColor: 'bg-orange-50',
    iconBg: 'bg-orange-100',
    textColor: 'text-orange-600',
    subtitle: '$3,840 proyectado',
    link: '/admin/monetization',
  },
];

// ─── 2. BOTONES GRANDES DE ACCIÓN ────────────────────────────────────

export interface DashboardQuickAction {
  id: string;
  label: string;
  icon: string;
  description: string;
  gradient: string;
  iconGradient: string;
  link: string;
  primary: boolean;
}

export const dashboardQuickActions: DashboardQuickAction[] = [
  {
    id: 'entrar-cabina',
    label: 'Entrar Cabina',
    icon: 'ri-message-3-line',
    description: 'Moderar mensajes y chatear con oyentes',
    gradient: 'from-emerald-500 to-teal-500',
    iconGradient: 'from-emerald-400 to-teal-400',
    link: '/admin/cabina',
    primary: true,
  },
  {
    id: 'crear-post',
    label: 'Crear Post',
    icon: 'ri-article-line',
    description: 'Publicar noticias, fotos o encuestas',
    gradient: 'from-amber-400 to-orange-500',
    iconGradient: 'from-amber-400 to-orange-400',
    link: '/admin/posts',
    primary: false,
  },
  {
    id: 'crear-evento',
    label: 'Crear Evento',
    icon: 'ri-calendar-event-line',
    description: 'Organizar conciertos, talleres o lives',
    gradient: 'from-violet-500 to-fuchsia-500',
    iconGradient: 'from-violet-400 to-fuchsia-400',
    link: '/admin/events',
    primary: false,
  },
  {
    id: 'crear-concurso',
    label: 'Crear Concurso',
    icon: 'ri-trophy-line',
    description: 'Lanzar trivias, sorteos o competencias',
    gradient: 'from-rose-500 to-pink-500',
    iconGradient: 'from-rose-400 to-pink-400',
    link: '/admin/contests',
    primary: false,
  },
  {
    id: 'transmitir',
    label: 'Transmitir',
    icon: 'ri-broadcast-line',
    description: 'Iniciar transmisión en vivo',
    gradient: 'from-sky-500 to-cyan-500',
    iconGradient: 'from-sky-400 to-cyan-400',
    link: '/admin/broadcast-center',
    primary: true,
  },
  {
    id: 'ver-comunidad',
    label: 'Ver Comunidad',
    icon: 'ri-group-line',
    description: 'Club de fans, top fans y seguidores',
    gradient: 'from-orange-500 to-red-500',
    iconGradient: 'from-orange-400 to-red-400',
    link: '/admin/community',
    primary: false,
  },
];

// ─── 3. ACTIVIDAD RECIENTE ───────────────────────────────────────────

export interface DashboardRecentActivity {
  id: string;
  type: 'oyente' | 'comentario' | 'seguidor' | 'concurso' | 'evento' | 'transmision' | 'mencion' | 'publicacion';
  message: string;
  entity: string;
  entityLink: string;
  timeAgo: string;
  timestamp: string;
  icon: string;
  color: string;
  bgColor: string;
}

export const dashboardRecentActivity: DashboardRecentActivity[] = [
  {
    id: 'act-1',
    type: 'oyente',
    message: 'se unió a la cabina',
    entity: 'María Fernández',
    entityLink: '/oyente',
    timeAgo: 'Hace 2 min',
    timestamp: '2026-06-21T14:28:00Z',
    icon: 'ri-headphone-line',
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
  },
  {
    id: 'act-2',
    type: 'comentario',
    message: 'comentó en tu post',
    entity: 'Carlos Mendoza',
    entityLink: '/oyente',
    timeAgo: 'Hace 5 min',
    timestamp: '2026-06-21T14:25:00Z',
    icon: 'ri-chat-1-line',
    color: 'text-teal-600',
    bgColor: 'bg-teal-50',
  },
  {
    id: 'act-3',
    type: 'seguidor',
    message: 'empezó a seguir tu radio',
    entity: 'Ana Lucía Romero',
    entityLink: '/oyente',
    timeAgo: 'Hace 8 min',
    timestamp: '2026-06-21T14:22:00Z',
    icon: 'ri-user-heart-line',
    color: 'text-amber-600',
    bgColor: 'bg-amber-50',
  },
  {
    id: 'act-4',
    type: 'concurso',
    message: 'ganó el concurso semanal',
    entity: 'Pedro Gutiérrez',
    entityLink: '/ganadores',
    timeAgo: 'Hace 12 min',
    timestamp: '2026-06-21T14:18:00Z',
    icon: 'ri-trophy-line',
    color: 'text-rose-600',
    bgColor: 'bg-rose-50',
  },
  {
    id: 'act-5',
    type: 'transmision',
    message: 'Tu transmisión lleva',
    entity: '45 min al aire',
    entityLink: '/admin/broadcast-center',
    timeAgo: 'Ahora',
    timestamp: '2026-06-21T14:30:00Z',
    icon: 'ri-broadcast-line',
    color: 'text-sky-600',
    bgColor: 'bg-sky-50',
  },
  {
    id: 'act-6',
    type: 'mencion',
    message: 'te mencionó en un post',
    entity: 'Radio Nacional',
    entityLink: '/radio/97.3',
    timeAgo: 'Hace 25 min',
    timestamp: '2026-06-21T14:05:00Z',
    icon: 'ri-at-line',
    color: 'text-violet-600',
    bgColor: 'bg-violet-50',
  },
  {
    id: 'act-7',
    type: 'publicacion',
    message: 'Tu post alcanzó',
    entity: '500 reacciones',
    entityLink: '/admin/posts',
    timeAgo: 'Hace 35 min',
    timestamp: '2026-06-21T13:55:00Z',
    icon: 'ri-fire-line',
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
  },
  {
    id: 'act-8',
    type: 'evento',
    message: 'confirmó asistencia a',
    entity: 'Concierto Sábado',
    entityLink: '/admin/events',
    timeAgo: 'Hace 40 min',
    timestamp: '2026-06-21T13:50:00Z',
    icon: 'ri-calendar-check-line',
    color: 'text-fuchsia-600',
    bgColor: 'bg-fuchsia-50',
  },
];

// ─── 4. TAREAS RECOMENDADAS ─────────────────────────────────────────

export interface DashboardTask {
  id: string;
  title: string;
  description: string;
  priority: 'alta' | 'media' | 'baja';
  actionLabel: string;
  actionLink: string;
  icon: string;
  completed: boolean;
  category: string;
}

export const dashboardTasks: DashboardTask[] = [
  {
    id: 'task-1',
    title: 'Responder mensajes pendientes',
    description: 'Tienes 12 mensajes de oyentes sin responder en la cabina. Mantener la conversación activa mejora tu score.',
    priority: 'alta',
    actionLabel: 'Ir a Cabina',
    actionLink: '/admin/cabina',
    icon: 'ri-message-2-line',
    completed: false,
    category: 'Cabina',
  },
  {
    id: 'task-2',
    title: 'Configurar programa de mañana',
    description: 'Tu programa "Mañanas Vibrantes" no tiene horario confirmado para mañana. Confírmalo para que aparezca en la guía.',
    priority: 'alta',
    actionLabel: 'Configurar',
    actionLink: '/admin/schedule',
    icon: 'ri-calendar-todo-line',
    completed: false,
    category: 'Programación',
  },
  {
    id: 'task-3',
    title: 'Subir foto de perfil del locutor',
    description: 'El locutor "Diego Ramírez" no tiene foto de perfil. Los locutores con foto reciben 3x más interacciones.',
    priority: 'media',
    actionLabel: 'Editar Locutor',
    actionLink: '/admin/hosts',
    icon: 'ri-user-smile-line',
    completed: false,
    category: 'Locutores',
  },
  {
    id: 'task-4',
    title: 'Publicar evento del sábado',
    description: 'El concierto del sábado aún no está publicado en RFW. Promocionalo ahora para que aparezca en la sección de Eventos.',
    priority: 'media',
    actionLabel: 'Crear Evento',
    actionLink: '/admin/events',
    icon: 'ri-calendar-event-line',
    completed: false,
    category: 'Eventos',
  },
  {
    id: 'task-5',
    title: 'Revisar reportes de moderación',
    description: 'Hay 2 reportes pendientes de revisión en tu comunidad. Resolverlos mantiene tu reputación limpia.',
    priority: 'media',
    actionLabel: 'Revisar',
    actionLink: '/admin/cabina/moderacion',
    icon: 'ri-shield-check-line',
    completed: false,
    category: 'Moderación',
  },
  {
    id: 'task-6',
    title: 'Actualizar datos de patrocinadores',
    description: 'Tus 3 patrocinadores activos necesitan actualización de logos. Patrocinadores actualizados mejoran tu visibilidad.',
    priority: 'baja',
    actionLabel: 'Actualizar',
    actionLink: '/admin/settings',
    icon: 'ri-building-line',
    completed: false,
    category: 'Configuración',
  },
  {
    id: 'task-7',
    title: 'Crear primer concurso del mes',
    description: 'Aún no lanzaste ningún concurso este mes. Las radios con concursos activos tienen 40% más engagement.',
    priority: 'baja',
    actionLabel: 'Crear Concurso',
    actionLink: '/admin/contests',
    icon: 'ri-trophy-line',
    completed: false,
    category: 'Concursos',
  },
];

// ─── 5. REGLAS ──────────────────────────────────────────────────────

export interface DashboardRule {
  id: string;
  title: string;
  description: string;
  icon: string;
  color: string;
}

export const dashboardRules: DashboardRule[] = [
  {
    id: 'rule-1',
    title: 'Todo lo importante visible sin navegar',
    description: 'Oyentes, seguidores, ranking, score, notificaciones e ingresos en la primera pantalla. Sin menús. Sin subpáginas. Sin scroll innecesario.',
    icon: 'ri-eye-line',
    color: 'emerald',
  },
  {
    id: 'rule-2',
    title: 'Una acción = un botón grande',
    description: 'Entrar a cabina, crear contenido, transmitir y ver la comunidad son un solo clic. Sin dropdowns. Sin submenús. Sin dudar.',
    icon: 'ri-cursor-line',
    color: 'amber',
  },
  {
    id: 'rule-3',
    title: 'Actividad y tareas en tiempo real',
    description: 'El dashboard se actualiza constantemente. Lo que pasó hace 2 minutos aparece. Lo que hay que hacer ahora se destaca.',
    icon: 'ri-time-line',
    color: 'violet',
  },
];

// ─── 6. STATS DEL DASHBOARD ──────────────────────────────────────────

export const dashboardStats = {
  totalRadiosUsing: 1247,
  avgCardsViewed: 5.8,
  avgActionsPerDay: 14.3,
  avgTimeOnDashboard: '2m 14s',
  mostClickedAction: 'Entrar Cabina',
  tasksCompletedToday: 1847,
  tasksCompletionRate: 78.4,
};

// ─── 7. RADIO DE EJEMPLO ────────────────────────────────────────────

export const demoRadio = {
  name: 'La Mega 92.5 FM',
  frequency: '92.5',
  slogan: 'Donde vive tu música',
  plan: 'Plan Profesional',
  daysActive: 847,
  nextBilling: '2026-07-15',
  streamStatus: 'online' as const,
  streamListeners: 1247,
};